import { useEffect, useState } from "react";
import {
  IFreshManSubStepPercentage,
  ISubStepConfiguration,
  ISubStepProcess,
} from "../../../models/freshman/freshmanProcess";
import LoaderSpinner from "../../../common-components/loader";
import { connect } from "react-redux";
import {
  getAllMainStepPercentage,
  getSubStepsByMainStepId,
  updateSubStepPercentage,
} from "../../../action/freshman/freshmanProcessActionCreator";
import { getAlertData } from "../../../helper/sweet-alert";
import SweetAlert from "react-bootstrap-sweetalert";
import { subStepStatus } from "../../../constants/commonConstants";
import { PercentageType } from "../../../constants/percentageType";

const SubStepProgress = (props: ISubStepProcess) => {
  const {
    subStepProcess,
    mainStepName,
    updateSubStepPercentage,
    userId,
    mainStepId,
    getSubStepsByMainStepId,
    getAllMainStepPercentage,
  } = props;
  const [percentage, setPercentage] = useState<string | undefined>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [showAlertCancel, setShowAlertCancel] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (subStepProcess?.length) {
      subStepProcess.forEach((substep: ISubStepConfiguration) => {
        if (
          substep.url !== "" &&
          substep.prerequisitesTotalPercentage === 100 &&
          substep?.percentageType == PercentageType.Api
        ) {
          const data: IFreshManSubStepPercentage = {
            subStepId: substep.subStepId,
            percentage: Number(percentage),
            studentId: userId,
            freshmanSubStepConfigurationId:
              substep.freshmanSubStepConfigurationId,
          };
          updateSubStepPercentage(data);
        }
      });
    }
  }, [subStepProcess]);

  const setShowTaskPercentage = (event: any) => {
    const listItem = event.target.closest("li");
    if (listItem) {
      listItem.classList.toggle("show-percentage");
    }
    percentage && setPercentage(undefined);
  };

  const getSubSteps = async (id: number) => {
    if (mainStepId && mainStepId > 0) {
      setIsLoading(true);
      try {
        await getSubStepsByMainStepId(id);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const onChange = (event: any) => {
    if (
      /^[a-zA-Z]+$/.test(event.target.value) ||
      (Number(event.target.value) <= 100 && !isNaN(event.target.value))
    ) {
      if (!/^[a-zA-Z]+$/.test(event.target.value)) {
        setPercentage(event.target.value);
      }
    }
  };

  // select class according to the substep percentage and prerequisite average percentage
  const selectClass = (subStep: ISubStepConfiguration | undefined) => {
    if (subStep?.percentage !== undefined) {
      if (
        subStep.status === subStepStatus.OnProgress ||
        subStep.status === subStepStatus.Awaiting_Verification
      ) {
        return "subtask-progress";
      } else if (subStep.status === subStepStatus.Done) {
        return "subtask-success";
      } else if (
        subStep.prerequisitesTotalPercentage != 100 &&
        subStep.prerequisites.length > 0 &&
        (subStep.status === subStepStatus.Waiting || subStep.status === 0)
      ) {
        return "subtask-disabled";
      } else if (subStep.status === subStepStatus.Waiting) {
        return "next-task";
      } else {
        return "";
      }
    }
  };

  // select status according to the substep percentage and prerequisite average percentage
  const selectStatus = (subStep: ISubStepConfiguration | undefined) => {
    if (subStep?.percentage !== undefined) {
      if (
        subStep.status === subStepStatus.OnProgress ||
        (subStep.status === subStepStatus.Waiting &&
          subStep.prerequisites.length === 0)
      ) {
        return "In Progress";
      } else if (subStep.status === subStepStatus.Awaiting_Verification) {
        return "Awaiting Verification";
      } else if (subStep.status === subStepStatus.Done) {
        return "Done";
      } else if (
        subStep.prerequisitesTotalPercentage != 100 &&
        subStep.prerequisites.length > 0 &&
        (subStep.status === subStepStatus.Waiting || subStep.status === 0)
      ) {
        return "Disabled";
      } else if (subStep.status === subStepStatus.Waiting) {
        return "Waiting";
      } else {
        return "";
      }
    }
  };

  const setAlert = (type: string) => {
    mainStepId && getSubSteps(mainStepId);
    getAllMainStepPercentage();
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const updatePercentage = async (subStep: ISubStepConfiguration) => {
    setIsLoading(true);
    const data: IFreshManSubStepPercentage = {
      subStepId: subStep.subStepId,
      percentage: Number(percentage),
      studentId: userId,
      freshmanSubStepConfigurationId: subStep.freshmanSubStepConfigurationId,
    };
    try {
      await updateSubStepPercentage(data, setAlert);
    } finally {
    }
  };

  // executed on clicking 'OK' in sweet alert.
  const onConfirm = () => {
    setShowAlert(false);
  };

  useEffect(() => {
    mainStepId && getSubSteps(mainStepId);
  }, [mainStepId]);

  return (
    <>
      <div className="col-md-9">
        <div className="taskdtl-wrap card-wrap">
          <div className="gridlines">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div id="step02" className="taskdtls-list active">
            <h2>{mainStepName}</h2>
            {subStepProcess?.map(
              (subSteps: ISubStepConfiguration, index: number) => (
                <ul className="subtask active">
                  <li
                    className={selectClass(subSteps)}
                    style={{
                      transform: `translateX(${
                        100 - (subSteps.percentage ?? 0)
                      }%)`,
                    }}
                    title={subSteps.description}
                  >
                    <div className="inner-card">
                      <span
                        className="taskprogress"
                        style={{ width: `${subSteps.percentage}%` }}
                      ></span>
                      <div className="num">{index + 1}</div>
                      <div className="dtls">
                        <h6>
                          <a
                            href={
                              subSteps.url && subSteps.percentage != 100
                                ? subSteps.url
                                : undefined
                            }
                            onClick={(e) => {
                              if (!subSteps.url) {
                                e.preventDefault();
                              }
                            }}
                            target={subSteps.url ? "_blank" : undefined}
                          >
                            {subSteps.name}
                          </a>
                        </h6>
                        <p className="para-hide-1">{subSteps.description}</p>
                      </div>
                      <div className="progress-txt">
                        <p>{selectStatus(subSteps)}</p>
                        {subSteps?.percentage !== 100 &&
                          subSteps?.percentageType === PercentageType.Manual &&
                          subSteps?.status !==
                            subStepStatus.Awaiting_Verification && (
                            <button
                              onClick={setShowTaskPercentage}
                              className="btn-subtask"
                            >
                              <i className="fa-solid fa-angle-down"></i>
                            </button>
                          )}
                      </div>
                    </div>
                    <div className="task-percentage">
                      <input
                        type="text"
                        value={
                          percentage !== undefined
                            ? percentage
                            : subSteps?.percentage! > 0
                              ? subSteps.percentage
                              : ''
                        }                        
                        onChange={onChange}
                        placeholder="Enter your completion percentage"
                      />
                      <button
                        id="btn-taskcompleted"
                        onClick={() => updatePercentage(subSteps)}
                      >
                        <i className="fa-solid fa-check"></i>
                      </button>
                    </div>
                  </li>
                </ul>
              )
            )}
            {isLoading && <LoaderSpinner />}
          </div>
        </div>
      </div>
      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={showAlertCancel}
        onCancel={() => {
          setShowAlertCancel(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={showAlertCancel ? "Yes" : "Ok"}
      ></SweetAlert>
    </>
  );
};

const mapDispatchToProps = {
  updateSubStepPercentage: (data: any, callback?: Function) =>
    updateSubStepPercentage(data, callback),
  getSubStepsByMainStepId: (id: number) => getSubStepsByMainStepId(id),
  getAllMainStepPercentage: () => getAllMainStepPercentage(),
};

function mapStateToProps(state: any) {
  return {
    userId: state.userDetails.userProfileData?.id,
    subStepProcess: state.freshmanProcess.subStepProcess,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubStepProgress);
